import { useTranslation } from "react-i18next"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { useError } from "../../context/useErrorContext"
import { useMessage } from "../../context/useMessageContext"
import { PostRequest } from "../../services/ApiClientService"
import { useGetServicePoints } from "./useGetServicePoints"

interface ServicePointSelfServiceActivationCode {
  activationCode: string
  expiresAtUtc?: string
}

export const useServicePointSelfService = () => {
  const { t } = useTranslation("general")

  const { setError } = useError()

  const { setMessage } = useMessage()

  const { handleGetServicePoints } = useGetServicePoints()

  const handleCreateActivationCode = async (
    servicePointId: number,
    onSuccess: (activation: ServicePointSelfServiceActivationCode) => void,
  ) => {
    try {
      const response = await PostRequest<ServicePointSelfServiceActivationCode>(
        API_ROUTES.SERVICE_POINT.CREATE_SELF_SERVICE_ACTIVATION_CODE(servicePointId),
        {},
      )

      if (!response.success || !response.data) {
        throw new Error(response.message)
      }

      onSuccess(response.data)
      return true
    } catch (error) {
      setError(t("label_title_erro"), error instanceof Error ? error.message : t("label_unknown_error_description"))
      return false
    }
  }

  const handleRevokeTablet = async (servicePointId: number, onSuccess: () => void) => {
    try {
      const response = await PostRequest(API_ROUTES.SERVICE_POINT.REVOKE_SELF_SERVICE(servicePointId), {})

      if (!response.success) {
        throw new Error(response.message)
      }

      await handleGetServicePoints(() => {})
      setMessage(t("servicePointSelfService:title"), t("servicePointSelfService:revoked"))
      onSuccess()
      return true
    } catch (error) {
      setError(t("label_title_erro"), error instanceof Error ? error.message : t("label_unknown_error_description"))
      return false
    }
  }

  return {
    handleCreateActivationCode,
    handleRevokeTablet,
  }
}
